__webpack_require__.p = "https://bundle.stayforlong.com/20251229.1/_next/";